/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { InlineObject } from '../model/models';
import { TourResource } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface ShowPublicTourServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Show public tour
     * 
     * @param tour The tour ID
     */
    getPublicTour(tour: number, extraHttpRequestParams?: any): Observable<TourResource>;

}
